"use client"

import { useState, useRef, useEffect } from "react"

// Estilos CSS optimizados para pantalla sin scroll
const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.5rem",
    overflow: "hidden",
    height: "100vh", // Asegurar que ocupe toda la altura de la pantalla
  },
  wrapper: {
    width: "100%",
    maxWidth: "1000px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%", // Ocupar toda la altura disponible
  },
  card: {
    backgroundColor: "white",
    borderRadius: "0.75rem",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    height: "100%", // Ocupar toda la altura disponible
    maxHeight: "calc(100vh - 2rem)", // Altura máxima para evitar desbordamiento
  },
  header: {
    background: "linear-gradient(to right, #003057,rgb(1, 65, 117))",
    padding: "0.5rem 1rem",
    color: "white",
    position: "relative",
    overflow: "hidden",
  },
  headerTitle: {
    fontSize: "1.125rem",
    fontWeight: "700",
    position: "relative",
    zIndex: "10",
    margin: "0",
  },
  headerSubtitle: {
    fontSize: "0.7rem",
    color: "#fce7f3",
    position: "relative",
    zIndex: "10",
    margin: "0.25rem 0 0 0",
  },
  formContainer: {
    padding: "0.75rem 1rem",
    flex: "1",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto", // Permitir scroll solo si es necesario
  },
  sectionTitle: {
    fontSize: "0.8rem",
    fontWeight: "600",
    color: "#003057",
    marginBottom: "0.5rem",
    paddingBottom: "0.125rem",
    borderBottom: "1px solid #e5e7eb",
  },
  formContent: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: "0.75rem",
    flex: "1",
  },
  formGroup: {
    marginBottom: "0.5rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  fieldContainer: {
    minHeight: "4.25rem", // Altura reducida para los contenedores de campos
    display: "flex",
    flexDirection: "column",
  },
  mapFieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    display: "block",
    fontSize: "0.7rem",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "0.125rem",
  },
  inputGroup: {
    position: "relative",
  },
  input: {
    width: "100%",
    height: "2rem",
    paddingLeft: "1.75rem",
    paddingRight: "0.5rem",
    borderRadius: "0.375rem",
    border: "1px solid #e5e7eb",
    transition: "all 0.3s ease",
    fontSize: "0.7rem",
  },
  inputFocus: {
    outline: "none",
    borderColor: "#003057",
    boxShadow: "0 0 0 2px rgba(0, 48, 87, 0.1)",
  },
  inputIcon: {
    position: "absolute",
    left: "0.5rem",
    top: "50%",
    transform: "translateY(-50%)",
    width: "0.875rem",
    height: "0.875rem",
    color: "#003057",
  },
  infoIcon: {
    width: "0.7rem",
    height: "0.7rem",
    color: "#9ca3af",
    marginLeft: "0.25rem",
    cursor: "help",
  },
  tooltip: {
    position: "absolute",
    top: "100%",
    left: "0",
    backgroundColor: "#1f2937",
    color: "white",
    padding: "0.375rem",
    borderRadius: "0.25rem",
    fontSize: "0.6rem",
    marginTop: "0.375rem",
    zIndex: "50",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    maxWidth: "180px",
    opacity: "0",
    visibility: "hidden",
    transition: "opacity 0.2s, visibility 0.2s",
  },
  tooltipVisible: {
    opacity: "1",
    visibility: "visible",
  },
  photoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "0.5rem",
  },
  photoLabel: {
    fontSize: "0.7rem",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "0.25rem",
    textAlign: "center",
  },
  photoUpload: {
    width: "4rem",
    height: "4rem",
    borderRadius: "50%",
    background: "linear-gradient(to right, #f9fafb, #f3f4f6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    border: "2px dashed #d1d5db",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginBottom: "0.25rem",
    position: "relative",
  },
  photoUploadHover: {
    borderColor: "#003057",
  },
  photoIcon: {
    width: "2rem",
    height: "2rem",
    color: "#9ca3af",
    transition: "color 0.3s ease",
  },
  photoIconHover: {
    color: "#003057",
  },
  photoImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  photoText: {
    fontSize: "0.7rem",
    color: "#003057",
    cursor: "pointer",
    transition: "color 0.3s ease",
  },
  photoTextHover: {
    color: "#be185d",
  },
  buttonContainer: {
    marginTop: "1rem",
    marginBottom: "1.5rem",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "0 1rem",
  },
  button: {
    width: "100%",
    height: "3rem",
    borderRadius: "0.375rem",
    background: "linear-gradient(to right, #003057,rgb(1, 65, 117))",
    color: "white",
    fontWeight: "600",
    fontSize: "1rem",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px -1px rgba(0, 48, 87, 0.2), 0 2px 4px -1px rgba(0, 48, 87, 0.1)",
    zIndex: 10,
    position: "relative",
  },
  buttonHover: {
    background: "linear-gradient(to right,rgb(0, 43, 77),rgb(1, 65, 117))",
    boxShadow: "0 10px 15px -3px rgba(0, 48, 87, 0.3), 0 4px 6px -2px rgba(0, 48, 87, 0.15)",
    transform: "translateY(-1px)",
  },
  buttonActive: {
    transform: "translateY(1px)",
  },
  successContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "1.5rem 1rem",
    height: "100%",
  },
  successIcon: {
    width: "3.5rem",
    height: "3.5rem",
    backgroundColor: "#d1fae5",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "0.75rem",
  },
  successCheckIcon: {
    width: "2rem",
    height: "2rem",
    color: "#10b981",
  },
  successTitle: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#1f2937",
    marginBottom: "0.375rem",
  },
  successMessage: {
    color: "#6b7280",
    textAlign: "center",
    marginBottom: "0.75rem",
    fontSize: "0.8rem",
  },
  successButton: {
    padding: "0.375rem 0.75rem",
    borderRadius: "0.375rem",
    background: "linear-gradient(to right, #003057,rgb(1, 65, 117))",
    color: "white",
    fontWeight: "500",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "0.8rem",
  },
  successButtonHover: {
    background: "linear-gradient(to right, #003057,rgb(1, 65, 117))",
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  loadingSpinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #003057",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  errorMessage: {
    color: "#ef4444",
    fontSize: "0.65rem",
    marginTop: "0.125rem",
    minHeight: "0.75rem", // Altura reducida para los mensajes de error
  },
  errorPlaceholder: {
    minHeight: "0.75rem", // Espacio reducido para mensajes de error
  },
  direccionInput: {
    height: "2.5rem", // Altura reducida para el textarea
    paddingTop: "0.375rem",
    paddingBottom: "0.375rem",
    resize: "none",
  },
  mapContainer: {
    height: "150px", // Altura reducida para el mapa
    width: "100%",
    borderRadius: "0.375rem",
    marginTop: "0.25rem",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    position: "relative",
  },
  mapLoading: {
    height: "150px", // Altura reducida para el mapa
    background: "#f1f5f9",
    borderRadius: "0.375rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#64748b",
    fontSize: "0.875rem",
  },
  searchContainer: {
    marginBottom: "0.5rem",
    position: "relative",
  },
  searchInput: {
    width: "100%",
    height: "2rem",
    paddingLeft: "1.75rem",
    paddingRight: "0.5rem",
    borderRadius: "0.375rem",
    border: "1px solid #e5e7eb",
    fontSize: "0.7rem",
  },
  searchIcon: {
    position: "absolute",
    left: "0.5rem",
    top: "50%",
    transform: "translateY(-50%)",
    width: "0.875rem",
    height: "0.875rem",
    color: "#003057",
  },
  col2: { 
    gridColumn: "span 2 / span 2" 
  },
  col3: {
    gridColumn: "span 3 / span 3"
  },
  col4: {
    gridColumn: "span 4 / span 4"
  },
  col6: {
    gridColumn: "span 6 / span 6"
  },
  col12: {
    gridColumn: "span 12 / span 12"
  },
  flexContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.75rem"
  },
  twoColumnLayout: {
    // display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: "1rem",
    width: "100%",
  },
  photoSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingTop: "1rem",
  },
  formSide: {
    flex: 1,
  },
  compactSection: {
    marginBottom: "0.5rem",
  },
}

// Componentes de iconos inline
const Icons = {
  Building: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="16" height="20" x="4" y="2" rx="2" ry="2" />
      <path d="M9 22v-4h6v4" />
      <path d="M8 6h.01" />
      <path d="M16 6h.01" />
      <path d="M12 6h.01" />
      <path d="M12 10h.01" />
      <path d="M12 14h.01" />
      <path d="M16 10h.01" />
      <path d="M16 14h.01" />
      <path d="M8 10h.01" />
      <path d="M8 14h.01" />
    </svg>
  ),
  FileText: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" x2="8" y1="13" y2="13" />
      <line x1="16" x2="8" y1="17" y2="17" />
      <line x1="10" x2="8" y1="9" y2="9" />
    </svg>
  ),
  User: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Briefcase: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Phone: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  CreditCard: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="20" height="14" x="2" y="5" rx="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </svg>
  ),
  UserCircle: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="10" r="3" />
      <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" />
    </svg>
  ),
  Info: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </svg>
  ),
  CheckCircle: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Mail: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="20" height="16" x="2" y="4" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  MapPin: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  ToggleLeft: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="20" height="12" x="2" y="6" rx="6" ry="6" />
      <circle cx="8" cy="12" r="2" />
    </svg>
  ),
  Search: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  ),
}

// Componente del mapa integrado
const MapComponent = ({ position, onPositionChange }) => {
  const mapRef = useRef(null)
  const markerRef = useRef(null)
  const mapContainerRef = useRef(null)
  const [mapLoaded, setMapLoaded] = useState(false)

  // Cargar las bibliotecas de Leaflet
  useEffect(() => {
    // Verificar si Leaflet ya está cargado
    if (window.L) {
      setMapLoaded(true)
      return
    }

    // Cargar CSS de Leaflet
    const linkElement = document.createElement("link")
    linkElement.rel = "stylesheet"
    linkElement.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
    linkElement.integrity = "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY="
    linkElement.crossOrigin = ""
    document.head.appendChild(linkElement)

    // Cargar JavaScript de Leaflet
    const scriptElement = document.createElement("script")
    scriptElement.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"
    scriptElement.integrity = "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo="
    scriptElement.crossOrigin = ""
    scriptElement.onload = () => {
      setMapLoaded(true)
    }
    document.head.appendChild(scriptElement)

    return () => {
      // Limpiar elementos si el componente se desmonta
      try {
        if (linkElement.parentNode) {
          document.head.removeChild(linkElement)
        }
        if (scriptElement.parentNode) {
          document.head.removeChild(scriptElement)
        }
      } catch (error) {
        console.log("Error al limpiar elementos del DOM:", error)
      }
    }
  }, [])

  // Inicializar el mapa cuando Leaflet esté cargado
  useEffect(() => {
    if (!mapLoaded || !mapContainerRef.current || !window.L) return

    const L = window.L

    // Inicializar el mapa si no existe
    if (!mapRef.current) {
      mapRef.current = L.map(mapContainerRef.current).setView([position.lat, position.lng], 15)

      // Añadir capa de OpenStreetMap
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(mapRef.current)

      // Añadir marcador
      markerRef.current = L.marker([position.lat, position.lng], {
        draggable: true,
      }).addTo(mapRef.current)

      // Evento cuando se arrastra el marcador
      markerRef.current.on("dragend", () => {
        const newPos = markerRef.current.getLatLng()
        onPositionChange({
          lat: newPos.lat,
          lng: newPos.lng,
        })
      })

      // Evento de clic en el mapa
      mapRef.current.on("click", (e) => {
        markerRef.current.setLatLng(e.latlng)
        onPositionChange({
          lat: e.latlng.lat,
          lng: e.latlng.lng,
        })
      })
    }

    return () => {
      // Limpiar el mapa si el componente se desmonta
      if (mapRef.current) {
        mapRef.current.remove()
        mapRef.current = null
        markerRef.current = null
      }
    }
  }, [mapLoaded])

  // Actualizar el marcador si cambia la posición externamente
  useEffect(() => {
    if (mapLoaded && mapRef.current && markerRef.current && window.L) {
      markerRef.current.setLatLng([position.lat, position.lng])
      mapRef.current.setView([position.lat, position.lng], mapRef.current.getZoom())
    }
  }, [position, mapLoaded])

  if (!mapLoaded) {
    return <div style={styles.mapLoading}>Cargando mapa...</div>
  }

  return (
    <div
      ref={mapContainerRef}
      style={{
        height: "100%",
        width: "100%",
        borderRadius: "0.375rem",
      }}
    />
  )
}

// Componente de campo de formulario para mantener consistencia
const FormField = ({
  id,
  label,
  icon,
  placeholder = "",
  type = "text",
  value = "",
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  activeField = "",
  error = "",
  tooltip = null,
  showTooltip = () => {},
  hideTooltip = () => {},
  required = false,
  isTextarea = false,
  children = null
}) => {
  const Icon = icon

  return (
    <div style={styles.fieldContainer}>
      <label style={styles.label} htmlFor={id}>
        {label}
        {tooltip && (
          <>
            <Icons.Info
              style={styles.infoIcon}
              onMouseEnter={() => showTooltip(tooltip.name)}
              onMouseLeave={() => hideTooltip(tooltip.name)}
            />
            {tooltip.visible && <div style={{ ...styles.tooltip, ...styles.tooltipVisible }}>{tooltip.text}</div>}
          </>
        )}
      </label>
      <div style={styles.inputGroup}>
        <Icon style={styles.inputIcon} />
        {isTextarea ? (
          <textarea
            id={id}
            placeholder={placeholder}
            style={
              activeField === id
                ? { ...styles.input, ...styles.inputFocus, ...styles.direccionInput }
                : { ...styles.input, ...styles.direccionInput }
            }
            value={value}
            onChange={onChange}
            onFocus={() => onFocus(id)}
            onBlur={onBlur}
            required={required}
          />
        ) : type === "select" ? (
          <select
            id={id}
            style={activeField === id ? { ...styles.input, ...styles.inputFocus } : styles.input}
            value={value}
            onChange={onChange}
            onFocus={() => onFocus(id)}
            onBlur={onBlur}
            required={required}
          >
            {children}
          </select>
        ) : (
          <input
            id={id}
            type={type}
            placeholder={placeholder}
            style={activeField === id ? { ...styles.input, ...styles.inputFocus } : styles.input}
            value={value}
            onChange={onChange}
            onFocus={() => onFocus(id)}
            onBlur={onBlur}
            required={required}
          />
        )}
      </div>
      <div style={styles.errorMessage}>{error || ""}</div>
    </div>
  )
}

// Componente principal
function FormularioRegistro() {
  // Coordenadas de El Carmen de Viboral, Antioquia
  const defaultPosition = {
    lat: 6.0856,
    lng: -75.3378,
  }

  const defaultAddress = "carrera 25 b 40 a 65, san fernando, el carmen de viboral, antioquia"
const ide = localStorage.getItem('idusuario');
        if (typeof ide !== "undefined") {
          
        }
        else {
          const idea = sessionStorage.getItem('idusuario');
          ide = idea;
        }
  const [formData, setFormData] = useState({
    estado: 1,
    nombre: "",
    apellido: "",
    correo: "",
    tipoDocumento: "CC",
    Identificacion: "",
    cargo: "",
    direccion: defaultAddress,
    telefono: "",
    cupo: "",
    foto: null,
    cliente_id: ide,
  })

  const [mapPosition, setMapPosition] = useState(defaultPosition)
  const [searchQuery, setSearchQuery] = useState("")
  const [foto, setFoto] = useState(null)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [activeField, setActiveField] = useState(null)
  const [tooltips, setTooltips] = useState({
    documento: false,
    cupo: false,
    correo: false,
    estado: false,
    direccion: false,
  })
  const [hoverStates, setHoverStates] = useState({
    photo: false,
    photoText: false,
    button: false,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const fileInputRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)

  // Detectar si es un dispositivo móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => {
      window.removeEventListener("resize", checkMobile)
    }
  }, [])

  // Actualizar la dirección cuando cambia la posición del mapa
  useEffect(() => {
    // Función para obtener la dirección a partir de las coordenadas (geocodificación inversa)
    const getAddressFromCoordinates = async () => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${mapPosition.lat}&lon=${mapPosition.lng}&zoom=18&addressdetails=1`,
          {
            headers: {
              "Accept-Language": "es",
              "User-Agent": "FormularioRegistro/1.0",
            },
          },
        )
        const data = await response.json()

        if (data && data.display_name) {
          // Solo actualizar si el campo no está activo (para evitar conflictos mientras el usuario escribe)
          if (activeField !== "direccion") {
            setFormData((prev) => ({
              ...prev,
              direccion: data.display_name,
            }))
          }
        }
      } catch (error) {
        console.error("Error al obtener la dirección:", error)
      }
    }

    getAddressFromCoordinates()
  }, [mapPosition, activeField])

  // Función para limpiar y normalizar direcciones
  const cleanAddress = (address) => {
    if (!address) return '';
    
    // Eliminar prefijos comunes como 'desde', 'hacia', etc.
    const cleaned = address
      .replace(/^(desde|hacia|hasta|dirección|direccion|dir|dir\.?|ubicación|ubicacion|ubic|ubic\.?|ubicar|encontrar|buscar|ir a|ir|a|al|la|el|los|las|un|una|unos|unas|y|e|o|u|de|del)\s+/gi, '')
      .trim();
    
    return cleaned;
  };

  // Función para buscar coordenadas con manejo de errores mejorado
  const searchCoordinates = async (query) => {
    if (!query || query.trim().length < 3) return null;
    
    try {
      // Limpiar la consulta
      const cleanedQuery = cleanAddress(query);
      
      // Primero intentar con la búsqueda estándar
      let response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanedQuery)}&addressdetails=1&limit=5`,
        {
          headers: {
            "Accept-Language": "es",
            "User-Agent": "TransOrientesApp/1.0",
          },
        }
      );
      
      let data = await response.json();
      
      // Si no hay resultados, intentar con un enfoque más flexible
      if (!data || data.length === 0) {
        // Eliminar palabras cortas y buscar de nuevo
        const simplifiedQuery = cleanedQuery
          .split(' ')
          .filter(word => word.length > 3)
          .join(' ');
          
        if (simplifiedQuery.length > 3) {
          response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(simplifiedQuery)}&addressdetails=1&limit=5`,
            {
              headers: {
                "Accept-Language": "es",
                "User-Agent": "TransOrientesApp/1.0",
              },
            }
          );
          data = await response.json();
        }
      }

      return data && data.length > 0 ? data[0] : null;
      
    } catch (error) {
      console.error("Error al buscar coordenadas:", error);
      return null;
    }
  };

  // Buscar coordenadas cuando cambia la dirección manualmente
  const handleAddressChange = async (e) => {
    const { id, value } = e.target;
    
    // Actualizar el estado del formulario
    setFormData(prev => ({
      ...prev,
      [id]: value,
    }));

    // Limpiar error cuando el usuario comienza a escribir
    if (errors[id]) {
      setErrors(prev => ({
        ...prev,
        [id]: null,
      }));
    }
  }

  // Manejar búsqueda de dirección
  const handleSearch = async (e) => {
    e.preventDefault();
    
    if (!searchQuery || searchQuery.trim().length < 3) {
      alert("Por favor ingrese al menos 3 caracteres para buscar");
      return;
    }

    // Mostrar indicador de carga
    setFormData(prev => ({
      ...prev,
      isLoading: true
    }));

    try {
      // Usar la nueva función de búsqueda mejorada
      const result = await searchCoordinates(searchQuery);

      if (result) {
        const { lat, lon, display_name } = result;
        
        // Actualizar la posición del mapa
        setMapPosition({
          lat: Number.parseFloat(lat),
          lng: Number.parseFloat(lon),
        });
        
        // Actualizar el campo de dirección
        setFormData(prev => ({
          ...prev,
          direccion: display_name,
          direccionEncontrada: true
        }));
        
        // Desplazarse al mapa
        const mapElement = document.querySelector('[style*="mapContainer"]');
        if (mapElement) {
          mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else {
        // Si no se encontraron resultados, intentar con una búsqueda más amplia
        const fallbackResponse = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=1`,
          {
            headers: {
              "Accept-Language": "es",
              "User-Agent": "TransOrientesApp/1.0",
            },
          }
        );
        
        const fallbackData = await fallbackResponse.json();
        
        if (fallbackData && fallbackData.length > 0) {
          const { lat, lon, display_name } = fallbackData[0];
          
          setMapPosition({
            lat: Number.parseFloat(lat),
            lng: Number.parseFloat(lon),
          });
          
          setFormData(prev => ({
            ...prev,
            direccion: display_name,
            direccionEncontrada: true
          }));
          
          // Desplazarse al mapa
          const mapElement = document.querySelector('[style*="mapContainer"]');
          if (mapElement) {
            mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          alert("No se encontraron resultados para la búsqueda. Por favor, intente con términos más específicos.");
        }
      }
    } catch (error) {
      console.error("Error al buscar la dirección:", error);
      alert("Ocurrió un error al buscar la dirección. Por favor, intente nuevamente.");
    } finally {
      // Ocultar indicador de carga
      setFormData(prev => ({
        ...prev,
        isLoading: false
      }));
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target
    setFormData({
      ...formData,
      [id]: value,
    })

    // Limpiar error cuando el usuario comienza a escribir
    if (errors[id]) {
      setErrors({
        ...errors,
        [id]: null,
      })
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const result = e.target?.result
        setFoto(result)
        setFormData({
          ...formData,
          foto: result,
        })
      }
      reader.readAsDataURL(file)
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.Identificacion) {
      newErrors.Identificacion = "El documento es requerido"
    }

    if (!formData.nombre) {
      newErrors.nombre = 'El nombre es requerido'
    } else if (formData.nombre.length < 2) {
      newErrors.nombre = 'El nombre debe tener al menos 2 caracteres'
    }
    
    // Validar apellido
    if (!formData.apellido) {
      newErrors.apellido = 'El apellido es requerido'
    } else if (formData.apellido.length < 2) {
      newErrors.apellido = 'El apellido debe tener al menos 2 caracteres'
    }
    
    // Validar correo
    if (!formData.correo) {
      newErrors.correo = 'El correo es requerido'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correo)) {
      newErrors.correo = 'Ingrese un correo electrónico válido'
    }

    if (!formData.telefono) newErrors.telefono = 'El teléfono es requerido'
    if (!formData.Identificacion) newErrors.Identificacion = 'La identificación es requerida'
    if (!formData.direccion) newErrors.direccion = 'La dirección es requerida'

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      // Desplazar a la parte inferior donde está el botón
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      })
      return
    }

    setIsLoading(true)

    try {
      // Preparar datos para la API
      const apiData = {
        ...formData,
        estado: Number.parseInt(formData.estado),
        Identificacion: Number.parseInt(formData.Identificacion),
        cliente_id: Number.parseInt(formData.cliente_id),
        // Añadir coordenadas del mapa
        latitud: mapPosition.lat.toString(),
        longitud: mapPosition.lng.toString(),
      }

      const response = await fetch("https://app.transorientesas.com/api/exterior/guardar-clientes-personal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(apiData),
      })

      const data = await response.json()

      if (response.ok) {
        setFormSubmitted(true)
      } else {
        setErrors({
          form: data.message || "Error al registrar el usuario",
        })
      }
    } catch (error) {
      console.error("Error al enviar el formulario:", error)
      setErrors({
        form: "Ocurrió un error al enviar el formulario. Por favor, intente nuevamente.",
      })
    } finally {
      setIsLoading(false)
    }
  }

  const showTooltip = (name) => {
    setTooltips((prev) => ({ ...prev, [name]: true }))
  }

  const hideTooltip = (name) => {
    setTooltips((prev) => ({ ...prev, [name]: false }))
  }

  const setHover = (name, value) => {
    setHoverStates((prev) => ({ ...prev, [name]: value }))
  }

  const resetForm = () => {
    setFormData({
      estado: 1,
      nombre: "",
      apellido: "",
      correo: "",
      Identificacion: "",
      cargo: "",
      direccion: defaultAddress,
      telefono: "",
      cupo: "",
      foto: null,
      cliente_id: "1",
    })
    setFoto(null)
    setFormSubmitted(false)
    setErrors({})
    setMapPosition(defaultPosition)
    setSearchQuery("")
  }

  const handleMapPositionChange = (newPosition) => {
    setMapPosition(newPosition)
  }

  return (
    <div style={styles.container}>
      {isLoading && (
        <div style={styles.loadingOverlay}>
          <div style={styles.loadingSpinner}></div>
        </div>
      )}

      <div style={styles.wrapper}>
        {/* Formulario principal */}
        <div style={styles.card}>
          {/* Encabezado con gradiente */}
          <div style={styles.header}>
            <h2 style={styles.headerTitle}>Registro de Usuario</h2>
            <p style={styles.headerSubtitle}>Complete el formulario para crear el usuario</p>
          </div>

          {formSubmitted ? (
            <div style={styles.successContainer}>
              <div style={styles.successIcon}>
                <Icons.CheckCircle style={styles.successCheckIcon} />
              </div>
              <h2 style={styles.successTitle}>¡Registro Exitoso!</h2>
              <p style={styles.successMessage}>Sus datos han sido registrados correctamente en nuestro sistema.</p>
              <button
                style={
                  hoverStates.button ? { ...styles.successButton, ...styles.successButtonHover } : styles.successButton
                }
                onMouseEnter={() => setHover("button", true)}
                onMouseLeave={() => setHover("button", false)}
                onClick={resetForm}
              >
                Volver al formulario
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={styles.formContainer}>
              <div style={isMobile ? { display: "flex", flexDirection: "column" } : styles.twoColumnLayout}>
                {/* Columna de la foto */}
                <div
                  style={
                    isMobile
                      ? {
                          display: "flex",
                          
                          alignItems: "center",
                          marginLeft: "10px", 
                          gap: "1rem",
                          marginBottom: "1rem",
                        }
                      : styles.photoSide
                  }
                >
                  <div style={styles.photoContainer}>
                    <label style={styles.photoLabel}>Foto de Perfil</label>
                    <div
                      style={
                        hoverStates.photo ? { ...styles.photoUpload, ...styles.photoUploadHover } : styles.photoUpload
                      }
                      onClick={() => fileInputRef.current?.click()}
                      onMouseEnter={() => setHover("photo", true)}
                      onMouseLeave={() => setHover("photo", false)}
                    >
                      {foto ? (
                        <img src={foto || "/placeholder.svg"} alt="Foto de perfil" style={styles.photoImg} />
                      ) : (
                        <Icons.UserCircle
                          style={
                            hoverStates.photo ? { ...styles.photoIcon, ...styles.photoIconHover } : styles.photoIcon
                          }
                        />
                      )}
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept="image/*"
                    />
                    <span
                      style={
                        hoverStates.photoText ? { ...styles.photoText, ...styles.photoTextHover } : styles.photoText
                      }
                      onClick={() => fileInputRef.current?.click()}
                      onMouseEnter={() => setHover("photoText", true)}
                      onMouseLeave={() => setHover("photoText", false)}
                    >
                      {foto ? "Cambiar foto" : "Subir foto"}
                    </span>
                  </div>

                  <div style={{ width: "100%",display:"none" }}>
                    <FormField
                      id="cliente_id"
                      label="Usuario ID"
                      icon={Icons.Building}
                      placeholder="ID del usuario"
                      value={formData.cliente_id}
                      onChange={handleInputChange}
                      onFocus={setActiveField}
                      onBlur={() => setActiveField(null)}
                      activeField={activeField}
                      style={{ display: "none" }}
                      required={true}
                    />
                  </div>
                </div>

                {/* Columna del formulario */}
                <div style={styles.formSide}>
                  <div style={styles.formContent}>
                    {/* Sección de información personal */}
                    <div style={styles.col12}>
                      <h3 style={styles.sectionTitle}>Información Personal</h3>
                    </div>

                    {/* Primera fila: Tipo de Documento y N° Documento */}
                    <div style={{ ...(isMobile ? styles.col12 : styles.col6), marginRight: isMobile ? 0 : '1rem' }}>
                      <FormField
                        id="tipoDocumento"
                        label="Tipo de Documento"
                        icon={Icons.FileText}
                        placeholder="Seleccione..."
                        type="select"
                        value={formData.tipoDocumento}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        error={errors.tipoDocumento}
                        tooltip={{
                          name: "tipoDocumento",
                          text: "Seleccione el tipo de documento de identidad",
                          visible: tooltips.tipoDocumento,
                        }}
                        showTooltip={showTooltip}
                        hideTooltip={hideTooltip}
                        required={true}
                      >
                        <option value="">Seleccione...</option>
                        <option value="CC">Cédula de Ciudadanía</option>
                        <option value="CE">Cédula de Extranjería</option>
                        <option value="NIT">NIT</option>
                        <option value="PAS">Pasaporte</option>
                        <option value="TI">Tarjeta de Identidad</option>
                        <option value="RC">Registro Civil</option>
                      </FormField>
                    </div>

                    <div style={isMobile ? styles.col12 : styles.col6}>
                      <FormField
                        id="Identificacion"
                        label="N° Documento"
                        icon={Icons.FileText}
                        placeholder="Número de documento"
                        value={formData.Identificacion}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        error={errors.Identificacion}
                        tooltip={{
                          name: 'documento',
                          text: 'Ingrese el número completo del documento sin puntos ni comas',
                          visible: tooltips.documento
                        }}
                        showTooltip={(name) => setTooltips(prev => ({ ...prev, [name]: true }))}
                        hideTooltip={(name) => setTooltips(prev => ({ ...prev, [name]: false }))}
                        required
                      />
                    </div>

                    {/* Segunda fila: Nombres y Apellidos */}
                    <div style={{ ...(isMobile ? styles.col12 : styles.col6), marginRight: isMobile ? 0 : '1rem' }}>
                      <FormField
                        id="nombre"
                        label="Nombres"
                        icon={Icons.User}
                        placeholder="Ingrese sus nombres"
                        value={formData.nombre}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        error={errors.nombre}
                        required={true}
                      />
                    </div>

                    <div style={{ ...(isMobile ? styles.col12 : styles.col6) }}>
                      <FormField
                        id="apellido"
                        label="Apellidos"
                        icon={Icons.User}
                        placeholder="Ingrese sus apellidos"
                        value={formData.apellido}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        error={errors.apellido}
                        required={true}
                      />
                    </div>

                    {/* Tercera fila: Correo Electrónico y Móvil Contacto */}
                    <div style={{ ...(isMobile ? styles.col12 : styles.col6), marginRight: isMobile ? 0 : '1rem' }}>
                      <FormField
                        id="correo"
                        label="Correo Electrónico"
                        icon={Icons.Mail}
                        placeholder="Ingrese su correo electrónico"
                        type="email"
                        value={formData.correo}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        error={errors.correo}
                        tooltip={{
                          name: "correo",
                          text: "Ingrese un correo electrónico válido",
                          visible: tooltips.correo,
                        }}
                        showTooltip={showTooltip}
                        hideTooltip={hideTooltip}
                        required={true}
                      />
                    </div>

                    <div style={{ ...(isMobile ? styles.col12 : styles.col6) }}>
                      <FormField
                        id="telefono"
                        label="Móvil Contacto"
                        icon={Icons.Phone}
                        placeholder="Ingrese su número móvil"
                        value={formData.telefono}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        error={errors.telefono}
                        required={true}
                      />
                    </div>

                    {/* Sección de información de contacto y profesional */}
                    <div style={styles.col12}>
                      <h3 style={styles.sectionTitle}>Información de Contacto y Profesional</h3>
                    </div>

                    <div style={styles.col12}>
                      <div style={styles.mapFieldContainer}>
                        <label style={styles.label} htmlFor="direccion">
                          Dirección
                          <Icons.Info
                            style={styles.infoIcon}
                            onMouseEnter={() => showTooltip("direccion")}
                            onMouseLeave={() => hideTooltip("direccion")}
                          />
                          {tooltips.direccion && (
                            <div style={{ ...styles.tooltip, ...styles.tooltipVisible }}>
                              Puede escribir una dirección o seleccionar un punto en el mapa
                            </div>
                          )}
                        </label>

                        {/* Buscador de direcciones */}
                        <div style={styles.searchContainer}>
                          <Icons.Search style={styles.searchIcon} />
                          <input
                            type="text"
                            placeholder="Buscar dirección"
                            style={styles.searchInput}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyPress={(e) => e.key === "Enter" && handleSearch(e)}
                          />
                          <button
                            onClick={handleSearch}
                            style={{
                              position: "absolute",
                              right: "0.5rem",
                              top: "50%",
                              transform: "translateY(-50%)",
                              background: "#003057",
                              color: "white",
                              border: "none",
                              borderRadius: "0.25rem",
                              padding: "0.25rem 0.5rem",
                              fontSize: "0.65rem",
                              cursor: "pointer",
                            }}
                          >
                            Buscar
                          </button>
                        </div>

                        <div style={styles.inputGroup}>
                          <Icons.MapPin style={styles.inputIcon} />
                          <input
                            id="direccion"
                            placeholder="Ingrese su dirección o seleccione en el mapa"
                            style={
                              activeField === "direccion" ? { ...styles.input, ...styles.inputFocus } : styles.input
                            }
                            value={formData.direccion}
                            onChange={handleAddressChange}
                            onFocus={() => setActiveField("direccion")}
                            onBlur={() => setActiveField(null)}
                            required={true}
                          />
                        </div>
                        <div style={styles.errorMessage}>{errors.direccion || ""}</div>
                        <div style={styles.mapContainer}>
                          <MapComponent position={mapPosition} onPositionChange={handleMapPositionChange} />
                        </div>
                      </div>
                    </div>

                    <div style={isMobile ? styles.col12 : styles.col6}>
                      <FormField
                        id="cargo"
                        label="Cargo del Usuario"
                        icon={Icons.Briefcase}
                        placeholder="Ingrese el cargo del usuario"
                        value={formData.cargo}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                      />
                    </div>

                    <div style={isMobile ? styles.col12 : styles.col6}>
                      <FormField
                        id="cupo"
                        label="Cupo Asignado del Usuario"
                        icon={Icons.CreditCard}
                        placeholder="Ingrese el cupo asignado al usuario"
                        value={formData.cupo}
                        onChange={handleInputChange}
                        onFocus={setActiveField}
                        onBlur={() => setActiveField(null)}
                        activeField={activeField}
                        tooltip={{
                          name: "cupo",
                          text: "Monto máximo asignado para las operaciones del usuario",
                          visible: tooltips.cupo,
                        }}
                        showTooltip={showTooltip}
                        hideTooltip={hideTooltip}
                      />
                    </div>

                    {/* Botón de envío */}
                    <div style={{ ...styles.col12, marginTop: "1rem",marginBottom: "3rem" }}>
                      <div style={styles.buttonContainer}>
                        <button
                          type="submit"
                          style={{
                            ...styles.button,
                            ...(hoverStates.button ? styles.buttonHover : {}),
                          }}
                          onMouseEnter={() => setHover("button", true)}
                          onMouseLeave={() => setHover("button", false)}
                          onMouseDown={() => setHover("buttonActive", true)}
                          onMouseUp={() => setHover("buttonActive", false)}
                          disabled={isLoading}
                        >
                          {isLoading ? "Procesando..." : "REGISTRAR USUARIO"}
                        </button>
                      </div>

                      {errors.form && (
                        <div style={{ ...styles.errorMessage, textAlign: "center", marginTop: "0.5rem" }}>
                          {errors.form}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>

      <style jsx global>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        html, body {
          margin: 0;
          padding: 0;
          height: 100%;
          overflow: hidden;
        }
        
        @media (max-width: 768px) {
          .twoColumnLayout {
            display: flex !important;
            flex-direction: column !important;
          }
          
          .formContent {
            display: flex !important;
            flex-direction: column !important;
          }
          
          .mapContainer {
            height: 120px !important;
          }
          
          .buttonContainer {
            position: sticky !important;
            bottom: 0 !important;
            background: white !important;
            padding: 1rem !important;
            margin-bottom: 3rem !important;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.1) !important;
            z-index: 100 !important;
          }
        }
      `}</style>
    </div>
  )
}

export default FormularioRegistro
